<div *ngIf="maxSizeExceeded" class="max-exceeded">La liste de r&eacute;sulats a &eacute;t&eacute; limit&eacute;e a {{ maxSize }} &eacute;l&eacute;ments pour raisons de performance</div>
<div class="mat-elevation-z8">
	<mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
	<table mat-table matSort [dataSource]="dataSource">
		<ng-container matColumnDef="jobExecutionId">
			<th mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
			<td mat-cell *matCellDef="let job"> {{ job.jobExecutionId }} </td>
		</ng-container>
	
		<ng-container matColumnDef="jobName">
			<th mat-header-cell *matHeaderCellDef mat-sort-header> Type </th>
			<td mat-cell *matCellDef="let job"> {{ job.jobName }} </td>
		</ng-container>
	
		<ng-container matColumnDef="startDate">
			<th mat-header-cell *matHeaderCellDef mat-sort-header> D&eacute;but </th>
			<td mat-cell *matCellDef="let job"> {{ job.startDate | date : 'dd/MM/yyyy HH:mm' }} </td>
		</ng-container>
	
		<ng-container matColumnDef="endDate">
			<th mat-header-cell *matHeaderCellDef mat-sort-header> Fin </th>
			<td mat-cell *matCellDef="let job"> {{ job.endDate | date : 'dd/MM/yyyy HH:mm' }} </td>
		</ng-container>
	
		<ng-container matColumnDef="status">
			<th mat-header-cell *matHeaderCellDef mat-sort-header> Parc concern&eacute; </th>
			<td mat-cell *matCellDef="let job"> {{ job.status }} </td>
		</ng-container>
	
		<ng-container matColumnDef="buttons">
			<th mat-header-cell *matHeaderCellDef></th>
			<td mat-cell *matCellDef="let job">
				<button
					type="button"
					class="btn btn-primary"
					[disabled]="job.status != 'FAILED'"
					(click)="displayExitMessage(job)"
					>
					Consulter
				</button>
			</td>
		</ng-container>

		<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
		<tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
	</table>
	<mat-paginator #paginator
		showFirstLastButtons
		[pageSizeOptions]="[5, 10, 20, 50]"
		[pageSize]="10"
		aria-label="Choisissez une page">
	</mat-paginator>
</div>